import type { TKey } from '../i18n';

export const STATUS_COLOR: Record<string, string> = {
  running: 'var(--success)',
  starting: 'var(--warning)',
  stopping: 'var(--warning)',
  rebooting: 'var(--warning)',
  creating: 'var(--info)',
  deleting: 'var(--danger)',
  stopped: 'var(--tg-hint)',
  error: 'var(--danger)',
};

export function statusColor(s: string): string {
  return STATUS_COLOR[s] ?? 'var(--tg-hint)';
}

export function statusLabel(
  t: (key: TKey, params?: Record<string, string | number>) => string,
  s: string,
): string {
  const known: Record<string, TKey> = {
    running: 'status.running',
    stopped: 'status.stopped',
    starting: 'status.starting',
    stopping: 'status.stopping',
    rebooting: 'status.rebooting',
    creating: 'status.creating',
    deleting: 'status.deleting',
    error: 'status.error',
    unknown: 'status.unknown',
  };
  const k = known[s];
  return k ? t(k) : s;
}
